(function (Drupal, once, duo) {
  Drupal.behaviors.languageSwitcher = {
    selectorClassName: 'js-language-toggle',
    selector: '.js-language-toggle',
    switchers: [],
    attach: function attach(context) {
      const behavior = Drupal.behaviors.languageSwitcher;
      behavior.switchers = once('switcher-once', behavior.selector);

      if (behavior.switchers.length <= 0) {
        return;
      }

      behavior.init();
      behavior.events();
    },

    init: function init() {
      const behavior = Drupal.behaviors.languageSwitcher;

      behavior.switchers.forEach((button) => {
        const langSelectId = 'lang-' + duo.Utils.uniqueId;
        const contentBlock = button.nextElementSibling;

        contentBlock.id = langSelectId;
        button.setAttribute('aria-controls', langSelectId);

        button.addEventListener('click', () => {
          behavior.toggleSwitcher(button);
        });
      });
    },

    events: function events() {
      const behavior = Drupal.behaviors.languageSwitcher;

      // click outside the language switcher close open switcher
      document.addEventListener('click', (ev) => {
        const activeEl = document.querySelector(behavior.selector + '[aria-expanded="true"]');
        if (activeEl) {
          const button = activeEl;
          const block = activeEl.closest('.js-language-switch-block');
          const clickedInside = block.contains(ev.target);

          if (!clickedInside) {
            behavior.toggleSwitcher(button);
          }
        }
      });

      // escape key
      document.addEventListener('keydown', (ev) => {
        const activeEl = document.querySelector(behavior.selector + '[aria-expanded="true"]');
        if (activeEl) {
          behavior.toggleSwitcher(activeEl);
        }
      });
    },

    toggleSwitcher: function toggleSwitcher(button) {
      const behavior = Drupal.behaviors.languageSwitcher;

      const state = button.getAttribute('aria-expanded') === 'true' ? false : true;
      const contentBlock = document.getElementById(button.getAttribute('aria-controls'));

      button.setAttribute('aria-expanded', state);

      if (state) {
        contentBlock.setAttribute('open', true);
        contentBlock.removeAttribute('hidden');

        contentBlock.addEventListener('animationend',() => {
          contentBlock.removeAttribute('open');
        },
        { once: true });
      } else {
        contentBlock.setAttribute('closing', true);

        contentBlock.addEventListener('animationend',() => {
          contentBlock.removeAttribute('closing');
          contentBlock.setAttribute('hidden', 'true');
        },
        { once: true });
      }
    }
  };
})(Drupal, once, window.duo = window.duo || {});
